import { FormLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { ErrorMessage, Label } from '../Label';

type SelectFieldProps<T extends { id: string | number }> = {
  value: T['id'] | undefined;
  options: T[];
  onChange: (value: T | undefined, event: SelectChangeEvent<T['id']>) => void;
  getLabel: (o: T) => string;
  label?: string;
  error?: string;
  placeholder?: string;
};

export const SelectField = <T extends { id: string | number }>(
  p: SelectFieldProps<T>,
) => (
  <div className="flex flex-col gap-1">
    <FormLabel className="flex flex-col gap-2">
      <Label
        content={p.label}
        error={p.error}
        id="select-field-id"
        style={{ marginBottom: '-5px' }}
      />
      <Select
        labelId="select-field-id"
        placeholder={p.placeholder || ''}
        error={p.error !== '' && p.error !== undefined}
        renderValue={(id) => {
          if (!id)
            return <span style={{ color: '#667085' }}>{p.placeholder}</span>;
          const o = p.options.find((o) => o.id === id);
          return o ? p.getLabel(o) : id;
        }}
        value={p.value || ''}
        onChange={(e) =>
          p.onChange(
            p.options.find((o) => o.id === e.target.value),
            e,
          )
        }
        displayEmpty
        required
      >
        <MenuItem value="" sx={{ display: 'none' }} />
        {p.options.map((o) => (
          <MenuItem key={o.id} value={o.id}>
            {p.getLabel(o)}
          </MenuItem>
        ))}
      </Select>
      <ErrorMessage content={p.error} />
    </FormLabel>
  </div>
);
